import React from 'react'
import ConsentGate from './ConsentGate'

interface GoogleFormProps {
  embedUrl: string
  className?: string
}

const GoogleForm: React.FC<GoogleFormProps> = ({
  embedUrl,
  className = ''
}) => {
  return (
    <ConsentGate
      type="google"
      serviceName="Google Forms"
      controllerName="Google"
      description="Google Forms uses cookies for analytics, form functionality, and may track your interaction with the form. Google may also use this data for advertising purposes."
      className={className}
    >
      <iframe
          width="100%"
          height="640px"
          src={`${embedUrl}?embedded=true`}
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
          style={{border: 'none', maxWidth: '100%', maxHeight: '100vh', borderRadius: '8px'}}
      >
        Loading…
      </iframe>
    </ConsentGate>
  )
}

export default GoogleForm
